import {Component, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ReplaySubject} from 'rxjs';
import {StepScreenModel} from '../../../../shared/step/step-screen.component';
import {FormErrors} from '../../../../../components/forms/validation/form-validator.class';
import {PremedicalEducation} from '../../../../../domain/model/education/premedical/premedical-education.model';
import {CountryService} from '../../../../../domain/model/info/country/country.service';
import {PremedicalEducationService} from '../../../../../domain/model/education/premedical/premedical-education.service';
import {FileLocationFactory} from '../../../../../components/files/service/file-location.class';
import {Model} from '../../../../../domain/model/common/model.class';
import {MonthPickerComponentModel} from '../../../../../components/forms/controls/monthpicker/month-picker.component';
import {AddressModel} from '../../../../../components/forms/controls/addresspicker/addresspicker.component';
import {AddressMapper} from '../../../../../domain/model/common/mappers/address-mapper.class';
import moment = require('moment');
import ProjectionInformation = Model.ProjectionInformation;

@Component({
    template: require('./premedical-screen.component.html')
})
export class PremedicalEducationScreenComponent {

    constructor(readonly educationService: PremedicalEducationService,
                countryService: CountryService,
                readonly fileLocationFactory: FileLocationFactory) {

        countryService.getCountriesProjection().subscribe(countries => this.countries = countries.map(c => c.name));
        countryService.getStates().subscribe(states => this.states = states.map(s => s.name));
    }

    // region Form
    readonly form$ = new ReplaySubject<NgForm>(1);

    @ViewChild(NgForm) set form(value: NgForm) {
        this.form$.next(value);
    }

    // endregion

    private readonly _addressMapper = new AddressMapper();

    countries: Array<string> = [];
    states: Array<string> = [];
    graduationDateMonthPickerModel = new MonthPickerComponentModel({
        minDate: moment().subtract(100, 'year'),
        maxDate: moment().add(5, 'year')
    });
    proofDocumentFileLocation = this.fileLocationFactory.create('premedicalEducation', 'currentUser', new ProjectionInformation('proofDocument'));

    stepScreenModel = new StepScreenModel<PremedicalEducation>({
        initialDataModel: new PremedicalEducation(),
        specificValidationMessages: {},
        _loadDataFn: () => {
            return this.educationService.getCurrentUserModel();
        },
        _submitDataFn: (model: PremedicalEducation) => {
            return this.educationService.updateCurrentUserModel(model);
        }
    });

    get model(): PremedicalEducation {
        return this.stepScreenModel.dataModel;
    }

    get formErrors(): FormErrors {
        return this.stepScreenModel.formErrors;
    }

    handleAddressUpdated(addressModel: AddressModel) {
        this._addressMapper.update(this.model.address, addressModel);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/education/steps/premedical/premedical/premedical-screen.component.ts